/* Collection presentation only. Product forms and filters keep the theme's components. */
(() => {
  if (!customElements.get('pp-collection-description')) {
    customElements.define('pp-collection-description', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.full = this.querySelector('[data-pp-description-full]');
        this.preview = this.querySelector('[data-pp-description-preview]');
        this.button = this.querySelector('button');
        const words = this.full.textContent.trim().split(/\s+/);
        if (words.length <= 32) return; // Short descriptions remain fully visible, including links.
        this.preview.textContent = words.slice(0, 32).join(' ') + ' …';
        this.button.hidden = false;
        this.setExpanded(false);
        this.button.addEventListener('click', () => {
          const expand = this.button.getAttribute('aria-expanded') !== 'true';
          this.setExpanded(expand);
          if (!expand && this.getBoundingClientRect().bottom < 0) this.scrollIntoView({block: 'start'});
        });
      }
      setExpanded(expand) {
        this.full.hidden = !expand; this.preview.hidden = expand;
        this.button.setAttribute('aria-expanded', String(expand));
        this.button.textContent = expand ? 'Læs mindre' : 'Læs mere';
      }
    });
  }
  if (window.ppCollectionPresentation) return;
  window.ppCollectionPresentation = true;
  const mobile = matchMedia('(max-width: 639px)');
  function orderPromotions() {
    document.querySelectorAll('[data-pp-collection-grid]').forEach(grid => {
      const children = Array.from(grid.children);
      const columns = Number(grid.dataset.mobileColumns) || 2;
      const firstIndex = Math.min(...children.filter(item => item.hasAttribute('data-pp-product-index')).map(item => Number(item.dataset.ppProductIndex)));
      const score = item => {
        if (item.hasAttribute('data-pp-product-index')) return Number(item.dataset.ppProductIndex);
        if (item.hasAttribute('data-pp-promo-before')) {
          const before = Number(item.dataset.ppPromoBefore);
          return mobile.matches ? Math.ceil((before - firstIndex) / columns) * columns + firstIndex - 0.5 : before - 0.5;
        }
        return Infinity;
      };
      const ordered = [...children].sort((a, b) => score(a) - score(b));
      // Move only misplaced nodes, retaining DOM reading/keyboard order with visual order.
      ordered.forEach((item, index) => {
        if (grid.children[index] !== item) grid.insertBefore(item, grid.children[index] || null);
      });
    });
  }
  orderPromotions();
  mobile.addEventListener('change', orderPromotions);
  document.addEventListener('collection:reloaded', orderPromotions);
  document.addEventListener('shopify:section:load', orderPromotions);
})();

// Native links work without JavaScript; only the optional mobile disclosure needs it.
if (!customElements.get('pp-category-tiles')) {
 customElements.define('pp-category-tiles', class extends HTMLElement {
  connectedCallback() {
   if (this.dataset.ready) return;
   this.dataset.ready = 'true';
   const button = this.querySelector('button');
   const list = this.querySelector('ul');
   if (!button || !list || list.children.length <= 4) return;
   button.hidden = false;
   button.addEventListener('click', () => {
    const expanded = this.toggleAttribute('data-expanded');
    button.setAttribute('aria-expanded', String(expanded));
    button.textContent = expanded ? 'Vis færre kategorier' : 'Vis flere kategorier';
   });
  }
 });
}
